import { APP_STORE_URL, PLAY_STORE_URL, useAppsFlyerClickUrl } from '../lib/storeLinks';
import appStoreBadge from '../assets/icons/app-store-badge.svg';
import playStoreBadge from '../assets/icons/play-store-badge.svg';
import tracking from '../lib/tracking';

interface AppStoreBadgesProps {
  className?: string;
  badgeHeight?: number;
  source?: string;
}

export default function AppStoreBadges({ className = '', badgeHeight = 44, source = 'landing' }: AppStoreBadgesProps) {
  const afClickUrl = useAppsFlyerClickUrl();

  const appstoreUrl = afClickUrl ? `${afClickUrl}&af_web_dp=${encodeURIComponent(APP_STORE_URL)}` : APP_STORE_URL;
  const playstoreUrl = afClickUrl ? `${afClickUrl}&af_web_dp=${encodeURIComponent(PLAY_STORE_URL)}` : PLAY_STORE_URL;
  return (
    <div className={`flex flex-row items-center gap-3 ${className}`}>
      <a
        href={appstoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download on the App Store"
        onClick={() => tracking.appStoreClicked(source)}
      >
        <img
          src={appStoreBadge}
          alt="Download on the App Store"
          style={{ height: badgeHeight }}
          className="hover:opacity-80 transition-opacity"
        />
      </a>
      <a
        href={playstoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get it on Google Play"
        onClick={() => tracking.playStoreClicked(source)}
      >
        <img
          src={playStoreBadge}
          alt="Get it on Google Play"
          style={{ height: badgeHeight }}
          className="hover:opacity-80 transition-opacity"
        />
      </a>
    </div>
  );
}
